<script lang="ts">
  import { ResponsiveVars } from '@twist/core';

  export let href: string;
  export let label: string;
  export let isExternal = false;

  const responsiveVars = new ResponsiveVars()
    .addFluid('font-size', [
      ['min', 12],
      ['lg', 'max', 14, 28],
      ['max', 24]
    ])
    .addFluid('margin-right', [
      ['min', 2],
      ['lg', 'max', 2, 4],
      ['max', 5]
    ])
    .addFluid('padding-x', [
      ['min', 6],
      ['lg', 'max', 6, 12],
      ['max', 12]
    ])
    .addFluid('padding-top', [
      ['min', 5.33],
      ['lg', 'max', 5.333, 10.667],
      ['max', 10.667]
    ])
    .addFluid('padding-bottom', [
      ['min', 6.667],
      ['lg', 'max', 6.667, 13.333],
      ['max', 13.333]
    ])
    .toCSS();
</script>

<a {href} class={responsiveVars} target={isExternal ? '_blank' : undefined} {...$$restProps}>
  {label}
</a>

<style lang="scss">
  a {
    font-family: var(--font-family-primary);
    font-weight: 600;
    display: flex;
    align-items: center;
    text-align: right;
    color: #fff;
    text-decoration: none;
    text-transform: uppercase;
    border-radius: 1000px;
    line-height: 116%;
    font-size: var(--font-size);
    padding: var(--padding-top) var(--padding-x) var(--padding-bottom);
    margin-right: var(--margin-right);
  }

  a:hover,
  a:focus {
    background-color: white;
    color: black;
    outline: none;
  }
</style>
